import { render, staticRenderFns } from "./AreaChoose.vue?vue&type=template&id=26e09b7e&scoped=true"
import script from "./AreaChoose.vue?vue&type=script&lang=js"
export * from "./AreaChoose.vue?vue&type=script&lang=js"
import style0 from "./AreaChoose.vue?vue&type=style&index=0&id=26e09b7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e09b7e",
  null
  
)

export default component.exports